import { ReportFilterOperationType, } from "peekdata-datagateway-api-sdk";
import { FilterTypes, IFilter } from "../models/filter";
import { ISelectedNode } from "../models/node";
export function getRequestOptions(options) {
    if (!options || options.length === 0) {
        return [];
    }
    return options.filter(function (option) { return option.value; }).map(function (option) { return option.value; });
}
export function getRequestSortedOptions(options) {
    if (!options || options.length === 0) {
        return [];
    }
    return options
        .filter(function (option) { return option.sorting; })
        .map(function (option) { return ({
        key: option.value,
        direction: option.sorting,
    }); });
}
export function getRequestDateRangesFilters(filters) {
    if (!filters || filters.length === 0) {
        return [];
    }
    return filters
        .filter(function (_a) {
        var key = _a.key, filterType = _a.filterType, from = _a.from, to = _a.to;
        return key && filterType === FilterTypes.DateRanges && from && to;
    })
        .map(function (_a) {
        var key = _a.key, from = _a.from, to = _a.to;
        return ({ key: key, from: from, to: to });
    });
}
export function getRequestSingleKeysFilters(filters) {
    console.log(filters);
    if (!filters || filters.length === 0) {
        return [];
    }
    return filters
        .filter(function (_a) {
        var key = _a.key, filterType = _a.filterType, operation = _a.operation, values = _a.values;
        return key &&
            filterType === FilterTypes.SingleKeys &&
            operation &&
            (values ||
                operation === ReportFilterOperationType.IS_NULL ||
                operation === ReportFilterOperationType.IS_NOT_NULL);
    })
        .map(function (_a) {
        var key = _a.key, operation = _a.operation, values = _a.values;
        return ({
            key: key,
            operation: operation,
            values: values
                ? values
                    .replace(/;{2,}/g, ";")
                    .replace(/^;/, "")
                    .replace(/[;]$/, "")
                    .split(";")
                : [],
        });
    });
}
export function getRequestSingleValuesFilters(filters) {
    if (!filters || filters.length === 0) {
        return [];
    }
    return filters
        .filter(function (_a) {
        var keys = _a.keys, filterType = _a.filterType, operation = _a.operation, value = _a.value;
        return keys &&
            keys.length > 0 &&
            filterType === FilterTypes.SingleValues &&
            operation &&
            value &&
            value.trim() !== "";
    })
        .map(function (_a) {
        var keys = _a.keys, operation = _a.operation, value = _a.value;
        return ({
            keys: keys,
            operation: operation,
            value: value,
        });
    });
}
